import React from 'react';
import { BellIcon, SearchIcon, PlusIcon } from 'lucide-react';
export const Header = () => {
  return <header className="bg-white border-b border-gray-200 py-3 px-6" data-id="element-10">
      <div className="flex items-center justify-between" data-id="element-11">
        <div className="flex items-center rounded-md bg-gray-100 px-3 py-1.5 w-64" data-id="element-12">
          <SearchIcon size={18} className="text-gray-500 mr-2" data-id="element-13" />
          <input type="text" placeholder="Search workspaces..." className="bg-transparent border-none outline-none text-sm flex-1" data-id="element-14" />
        </div>
        <div className="flex items-center gap-4" data-id="element-15">
          <button className="flex items-center gap-2 bg-blue-600 text-white px-3 py-1.5 rounded-md text-sm" data-id="element-16">
            <PlusIcon size={16} data-id="element-17" />
            New Workspace
          </button>
          <div className="relative" data-id="element-18">
            <BellIcon size={20} className="text-gray-600 cursor-pointer" data-id="element-19" />
            <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center" data-id="element-20">
              3
            </span>
          </div>
          <div className="flex items-center gap-2" data-id="element-21">
            <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white font-medium" data-id="element-22">
              JD
            </div>
            <span className="text-sm font-medium" data-id="element-23">John Doe</span>
          </div>
        </div>
      </div>
    </header>;
};